module.exports = __webpack_public_path__ + "img/varlet.24010be1.png";